import React, {
  createContext,
  useContext,
  useCallback,
  useState,
  useMemo
} from "react";
import PropTypes from "prop-types";

const StepsDrawerCtxt = createContext(null);

const StepsDrawerProvider = ({ children }) => {
  // Get loaded view from url
  const loadedView = window.location.href.split("/").pop() || "";

  const [state, setState] = useState({
    open: false,
    selectedIndex: loadedView,
    selectedChild: {},
    nestedItems: {}
  });  

  // toggle drawer, memoized
  const toggleDrawer = useCallback(() => {    
    setState(prevState => ({
      ...prevState,
      open: !prevState.open
    }));
  }, []);

  const setSelectedIndex = useCallback(index => {
    setState(prevState => ({
      ...prevState,
      selectedIndex: index
    }));
  }, []);

  const setSelectedChild = useCallback(child => {
    setState(prevState => ({
      ...prevState,
      selectedChild: child
    }));
  }, []);

  const setNestedItems = useCallback(itemName => {
    setState(prevState => ({
      ...prevState,
      nestedItems: {
        ...prevState.nestedItems,
        [itemName]: !prevState.nestedItems[itemName]
      }
    }));
  }, []);

  const clearNestedItems = useCallback(() => {
    setState(prevState => ({
      ...prevState,
      nestedItems: {}
    }));
  }, []);

  const contextValue = useMemo(
    () => ({
      state,
      setState,
      toggleDrawer,
      setSelectedIndex,
      setSelectedChild,
      setNestedItems,
      clearNestedItems
    }),
    [state, toggleDrawer]
  );

  return (
    <StepsDrawerCtxt.Provider value={contextValue}>
      {children}
    </StepsDrawerCtxt.Provider>
  );
};

export const StepsDrawerConsumer = () => {
  return useContext(StepsDrawerCtxt);
};

export default StepsDrawerProvider;

StepsDrawerProvider.propTypes = {
  children: PropTypes.node
};
